import { Box, Button, useStyleConfig } from '@chakra-ui/react';
import { FaDownload } from 'react-icons/fa';
import { download, downloadCoverLetter, onLink } from '../../../handlers';
import React from 'react';
import { parseCoverLetter } from '../../../formSections/Parser/utils';


const Header = ({ props }) => {
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  return (
    <Box className='headerWrap'>
        <Box >
        </Box>
        <Box className='downloadButtonWrap'>
          <Button
            sx={{...buttonStyles.download}}
            leftIcon={<FaDownload />}
            onClick={e => download(props)}
          >
            Download
          </Button>
        </Box>
      </Box>
  );

}
export default Header;
